export default __webpack_public_path__ + "static/media/promotion.4e158b41.png";